<template>
  <div class="policy-content">
    <div class="map" :id="mapId" ref="myEchart"></div>
  </div>
</template>

<script>
//import echarts from 'echarts'
import "../../../utils/china.js";
// import api from "@/api/api.js";
export default {
  name: "echarts",
  props: {
    mapData: {
      type: Object,
    },
  },
  data() {
    return {
      resultList: [],
      tableData: [
        {
          company: "江苏",
          todayPremium: "20",
          yearPercent: "89",
          peoplePercent: "30",
        },
        {
          company: "内蒙古",
          todayPremium: "20",
          yearPercent: "89",
          peoplePercent: "30",
        },
        {
          company: "浙江",
          todayPremium: "20",
          yearPercent: "89",
          peoplePercent: "30",
        },
        {
          company: "山东(不含青岛)",
          todayPremium: "20",
          yearPercent: "89",
          peoplePercent: "30",
        },
        {
          company: "河南",
          todayPremium: "20",
          yearPercent: "89",
          peoplePercent: "30",
        },
        {
          company: "天津",
          todayPremium: "20",
          yearPercent: "89",
          peoplePercent: "30",
        },
        {
          company: "广东",
          todayPremium: "20",
          yearPercent: "89",
          peoplePercent: "30",
        },
        {
          company: "广西",
          todayPremium: "20",
          yearPercent: "89",
          peoplePercent: "30",
        },
        {
          company: "湖南",
          todayPremium: "20",
          yearPercent: "89",
          peoplePercent: "30",
        },
        {
          company: "山西",
          todayPremium: "20",
          yearPercent: "89",
          peoplePercent: "30",
        },
        {
          company: "福建",
          todayPremium: "20",
          yearPercent: "89",
          peoplePercent: "30",
        },
        {
          company: "四川",
          todayPremium: "20",
          yearPercent: "89",
          peoplePercent: "30",
        },
        {
          company: "青岛",
          todayPremium: "20",
          yearPercent: "89",
          peoplePercent: "30",
        },
      ],
    };
  },
  computed: {
    mapId() {
      return "echarts" + Math.random() * 1000000;
    },
  },
  created() {
  },
  mounted() {
    this.queryMapAllDatas();
    this.init();
    let map = this.$echarts.init(this.$refs.myEchart);
    let that = this;
    map.on("click", function (param) {
      that.resultList = [];
      that.showValue(param.name);
    });
  },
  methods: {
    showValue(val) {
      this.resultList = [{ comlevel: val, comnum: "31", nums: "30" }];
    },
    chinaConfigure() {
      let arr = [
        { name: "北京", value: Math.round(Math.random() * 2000) },
        { name: "天津", value: Math.round(Math.random() * 2000) },
        { name: "上海", value: Math.round(Math.random() * 2000) },
        { name: "重庆", value: Math.round(Math.random() * 2000) },
        { name: "河北", value: 0 },
        { name: "河南", value: Math.round(Math.random() * 2000) },
        { name: "云南", value: 5 },
        { name: "辽宁", value: 305 },
        { name: "黑龙江", value: Math.round(Math.random() * 2000) },
        { name: "湖南", value: 200 },
        { name: "安徽", value: Math.round(Math.random() * 2000) },
        { name: "山东", value: Math.round(Math.random() * 2000) },
        { name: "新疆", value: Math.round(Math.random() * 2000) },
        { name: "江苏", value: Math.round(Math.random() * 2000) },
        { name: "浙江", value: Math.round(Math.random() * 2000) },
        { name: "江西", value: Math.round(Math.random() * 2000) },
        { name: "湖北", value: Math.round(Math.random() * 2000) },
        { name: "广西", value: Math.round(Math.random() * 2000) },
        { name: "甘肃", value: Math.round(Math.random() * 2000) },
        { name: "山西", value: Math.round(Math.random() * 2000) },
        { name: "内蒙古", value: Math.round(Math.random() * 2000) },
        { name: "陕西", value: Math.round(Math.random() * 2000) },
        { name: "吉林", value: Math.round(Math.random() * 2000) },
        { name: "福建", value: Math.round(Math.random() * 2000) },
        { name: "贵州", value: Math.round(Math.random() * 2000) },
        { name: "广东", value: Math.round(Math.random() * 2000) },
        { name: "青海", value: Math.round(Math.random() * 2000) },
        { name: "西藏", value: Math.round(Math.random() * 2000) },
        { name: "四川", value: Math.round(Math.random() * 2000) },
        { name: "宁夏", value: Math.round(Math.random() * 2000) },
        { name: "海南", value: Math.round(Math.random() * 2000) },
        { name: "台湾", value: Math.round(Math.random() * 2000) },
        { name: "香港", value: Math.round(Math.random() * 2000) },
        { name: "澳门", value: Math.round(Math.random() * 2000) },
      ];
      let myChart = this.$echarts.init(this.$refs.myEchart);
      window.onresize = myChart.resize;
      myChart.setOption({
        backgroundColor: "white",
        tooltip: {
          formatter: "{b}", //浮动提示框数据格式
        },
        geo: {
          map: "china",
          roam: false,
          top: "0.30rem",
          left: "0.1rem",
          right: "0.10rem",
          bottom: "0.30rem",
          label: {
            normal: {
              show: false, // 是否显示对应地名
              textStyle: {
                color: "rgba(0,0,0,0.4)",
              },
            },
            emphasis: {
              show: true,
            },
          },
          itemStyle: {
            normal: {
              borderColor: "white",
              areaColor: "#dae9f9",
            },
          },
          emphasis: {
            itemStyle: {
              areaColor: "#77a4cc",
            },
          },
        },
        series: [
          {
            type: "scatter",
            coordinateSystem: "geo", // 对应上方配置
          },
          {
            name: "", // 浮动框的标题
            type: "map",
            geoIndex: 0,
            data: arr,
          },
        ],
      });
    },
    init() {
      const excludeArr = [
        "江苏",
        "内蒙古",
        "浙江",
        "山东",
        "河南",
        "天津",
        "广东",
        "广西",
        "湖南",
        "山西",
        "福建",
        "四川",
      ];
      var myEchart = this.$echarts.init(this.$refs.myEchart);
      let options = {
        color: ["#B2B2B2", "#31D493"],
        tooltip: {
          trigger: "item",
          backgroundColor: "#FFFFFF",
          position: 'center',
          textStyle: {
            color: "black",
            decoration: "none",
            fontWeight: "bold",
          },
          formatter: function (params) {
            if (excludeArr.includes(params.name) === true) {
              return `
                <style>
                   table.hoverTable{border-collapse: collapse;padding: 0.15rem;left:0}
                   table.hoverTable th{background-color: #F2F2F2;font-weight:bold;padding: 0.08rem}
                   table.hoverTable tr{border-top: 0.01rem, solid #FBFBFB;background: #FBFBFB;}
                   table.hoverTable td{font-size: 0.12rem;color: #7C8088;padding: 0.08rem}
                </style>
                <table class="hoverTable" width="100">
                    <tr>
                      <th>分公司</th>
                      <th>市级机构数量</th>
                      <th>县级机构数量</th>
                      <th>人员数量</th>
                    </tr>
                    <tr align="center">
                      <td>${params.name}</td>
                      <td>20</td>
                      <td>89</td>
                      <td>30</td>
                    </tr>
                  </table>`;
            }
          },
        },

        roamController: {
          show: true,
          x: "right",
          mapTypeControl: {
            china: true,
          },
        },

        visualMap: {
          show: false,
          left: "center",
          orient: "horizontal",
          pieces: [
            { gte: 10, lte: 20, label: "已有地区2" },
            { gte: 3, lte: 9, label: "已有地区1" },
            { lte: 2, label: "未有地区" },
          ],
          inRange: {
            color: ["#EFEFEF", "#31D493"],
          },
        },

        series: [
          {
            name: "未有地区",
            type: "map",
            mapType: "china",
            roam: false,
            zoom:1.2,
            itemStyle: {
              normal: {
                borderWidth: 0.2,
                label: { show: false },
              },
              emphasis: {
                label: { show: false },
                // 地图区域的高亮颜色
                areaColor: "#2AB57D",
              },
            },
            data: [],
          },

          {
            name: "已有地区1",
            type: "map",
            mapType: "china",
            roam: false,
            itemStyle: {
              normal: { label: { show: false } },
              emphasis: {
                label: { show: false },
                areaColor: "#31D493",
              },
            },
            data: [
              { name: "山东", value: 5 },
              { name: "河南", value: 5 },
              { name: "天津", value: 5 },
              { name: "广东", value: 5 },
              { name: "广西", value: 5 },
              { name: "湖南", value: 5 },
              { name: "山西", value: 5 },
              { name: "福建", value: 5 },
              { name: "四川", value: 5 },
            ],
          },

          {
            name: "已有地区2",
            type: "map",
            mapType: "china",
            roam: false,
            itemStyle: {
              normal: { label: { show: false } },
              emphasis: {
                label: { show: false },
                areaColor: "#31D493",
              },
            },
            data: [
              { name: "江苏", value: 11 },
              { name: "内蒙古", value: 11 },
              { name: "浙江", value: 11 },
            ],
          },
        ],
      };

      myEchart.on("mouseover", function (params) {
        if (excludeArr.includes(params.name) === false)
          myEchart.dispatchAction({
            type: "downplay",
          });
      });

      myEchart.setOption(options);
    },
    queryMapAllDatas() {
      this.dataList = [];
      // this.$http.post(api.findServiceNetwork).then((res) => {
      //   this.dataList = res.data;
      // });
    },
  },
};
</script>

<style scoped>
.policy-content {
  width: 100%;
  height: auto;
}

.sub-title {
  width: 100%;
  height: 0.24rem;
  display: flex;
}

.sub-title-bar {
  width: 0.04rem;
  height: 0.16rem;
  background: #31d493;
  position: relative;
  top: 0.04rem;
}

.sub-title-text {
  font-size: 0.16rem;
  font-weight: bold;
  color: #333;
  line-height: 0.24rem;
  height: 0.24rem;
  margin-left: 0.06rem;
}

.summaryTable table {
  width: 100%;
  background: white;
  text-align: center;
  box-shadow: 0px 0.03rem 0.06rem rgba(192, 201, 210, 0.26);
  border-radius: 0.08rem;
  line-height: 0.3rem;
}
.map {
  height: 3.5rem;
  width: 100%;
  border-radius: 0.10rem;
  margin-top: 0.1rem;
  margin-bottom: 0.2rem;
  background: #FFFFFF;
  box-shadow: 0px 0.03rem 0.06rem rgba(192, 201, 210, 0.27);
}
th {
  border: none;
  color: rgba(102, 102, 102, 1);
  font-size: 14px;
  font-weight: normal;
}
td {
  border: 1px solid rgba(238, 238, 238, 1);
}
</style>  


// WEBPACK FOOTER //
// src/pages/operationSummary/components/serviceNetSummary.vue